
// ── View switcher
function switchView(name, tab) {
  document.querySelectorAll('.book-view').forEach(v => v.classList.remove('active'));
  document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
  document.getElementById('view-' + name).classList.add('active');
  tab.classList.add('active');
}

// ── FAQ toggle
function toggleFaq(btn) {
  const item = btn.parentElement;
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// ── Reviews scroller
let reviewPos = 0;
function scrollReviews(dir) {
  const track = document.getElementById('reviewsTrack');
  const card = track.querySelector('.review-card');
  const cardW = card.offsetWidth + 20;
  const maxPos = track.scrollWidth - track.parentElement.offsetWidth;
  reviewPos = Math.max(0, Math.min(maxPos, reviewPos + dir * cardW));
  track.style.transform = 'translateX(-' + reviewPos + 'px)';
}

// ── Cart count (works on Shopify, gracefully ignored on static HTML)
function updateCartCount() {
  try {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count || 0;
        const badge = document.getElementById('cartCount');
        if (badge) {
          badge.textContent = count;
          badge.style.display = count > 0 ? 'flex' : 'none';
        }
      }).catch(() => {});
  } catch(e) {}
}
updateCartCount();

// ── Add to cart handler (Shopify Ajax)
function handleAddToCart(e) {
  e.preventDefault();
  const btn = document.getElementById('addToCartBtn');
  const originalText = btn.textContent.trim();
  btn.textContent = 'Adding...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: 52975044067671, quantity: 1 })
  }).then(r => r.json()).then((data) => {
    if (data.id) {
      btn.textContent = 'Added to Cart ✓';
      updateCartCount();
      setTimeout(() => { btn.textContent = originalText; }, 2500);
    } else {
      window.location.href = '/cart/add?id=52975044067671&quantity=1';
    }
  }).catch(() => {
    window.location.href = '/cart/add?id=52975044067671&quantity=1';
  });
}

// ── Scroll reveal
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
  });
}, { threshold: 0.08 });
document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

// ── Gallery prev/next stepper
function stepGallery(dir) {
  const thumbs = Array.from(document.querySelectorAll('.image-thumbs .thumb'));
  const activeThumb = document.querySelector('.image-thumbs .thumb.active');
  const currentIdx = thumbs.indexOf(activeThumb);
  const nextIdx = (currentIdx + dir + thumbs.length) % thumbs.length;
  thumbs[nextIdx].click();
}
